import Svg from '../generated/Editor';
import { Icon, type IconProps } from './Icon';

export const EditorIcon = (props: IconProps) => <Icon component={Svg} name="editor" {...props} />;
